/* eslint-disable no-useless-escape */
import * as isValidCpf from '@brazilian-utils/is-valid-cpf'
import { parseToString } from './parseNumbers'

const validateEmail = email => {
  if (!email) {
    return null
  }

  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email.trim().toLowerCase())
}

const validateCpf = cpf => isValidCpf.isValidCpf(cpf)

const validatePhone = phone => {
  const onlyNumbers = parseToString(phone)
  return (
    (onlyNumbers.length >= 10 && onlyNumbers.length <= 11) ||
    onlyNumbers.length === 0
  )
}

const validateEntry = (price, entry) => Number(entry) >= Number(price) * 0.1

const validateMandatoryPhone = phone => {
  const onlyNumbers = phone.replace(/[^0-9]/g, '')

  return onlyNumbers.length >= 10 && onlyNumbers.length <= 11
}

const validateFullName = fullName =>
  /^([a-zA-Z\u00C0-\u017F]+\s)+[a-zA-Z\u00C0-\u017F]+$/.test(fullName.trim())

const validateCurrency = value => Number(value) > 0

const validateDate = dateString => {
  if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) return false

  const parts = dateString.split('/')
  const day = parseInt(parts[0], 10)
  const month = parseInt(parts[1], 10)
  const year = parseInt(parts[2], 10)

  if (year < 1000 || year > 3000 || month === 0 || month > 12) return false

  const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
    monthLength[1] = 29

  return day > 0 && day <= monthLength[month - 1]
}
export {
  validateCpf,
  validateCurrency,
  validateEmail,
  validateEntry,
  validateFullName,
  validatePhone,
  validateDate,
  validateMandatoryPhone,
}
